import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import { useLazyGetManageSubscriptionLinkQuery } from 'store/services/users';
import routes from 'constants/routes';

const GamePausedNotice = () => {
  const [getManageSubscriptionLink, { data: manageSubscriptionLink }] = useLazyGetManageSubscriptionLinkQuery();

  useEffect(() => {
    if (manageSubscriptionLink) {
      window.location.href = manageSubscriptionLink.url;
    }
  }, [manageSubscriptionLink]);

  const handleUnsubscribeClick = e => {
    e.preventDefault();
    getManageSubscriptionLink();
  };

  return (
    <Box
      position="fixed"
      top="48px"
      left="50%"
      transform="translateX(-50%)"
      width="100%"
      minH="calc(100dvh - 48px)"
      w="100%"
      maxW="400px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px="20px"
      zIndex="99"
    >
      <Box textAlign="center" maxWidth="300px" fontSize="18px" fontWeight="600" style={{ textWrap: 'balance' }}>
        <Text mb="20px">5 Card Draw has been paused while our team makes changes to the game this Summer.</Text>
        <Text mb="10px">
          We will still accept all coin{' '}
          <Link
            to={routes.trade}
            style={{
              color: '#0084FF',
              cursor: 'pointer',
            }}
          >
            trades
          </Link>{' '}
          for prizes.
        </Text>
        <Text lineHeight="24px">
          Please find a link to unsubscribe{' '}
          <Link
            to="#"
            onClick={handleUnsubscribeClick}
            style={{
              color: '#0084FF',
              cursor: 'pointer',
            }}
          >
            here
          </Link>
          .
        </Text>
      </Box>
    </Box>
  );
};

export default GamePausedNotice;
